import theme from "@/theme/theme";
import styled from "@emotion/styled";

export const StyledWrapper = styled.div`
  flex-direction: column;
  margin-top: 20px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  ${theme.breakpoints.down("md")} {
    & img {
      width: 125px;
      height: 125px;
    }
  }
  ${theme.breakpoints.down("sm")} {
    & img {
      width: 100px;
      height: 100px;
    }
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 570px;
  margin-bottom: 50px;
  margin-top: 50px;
  ${theme.breakpoints.down("sm")} {
    width: 90%;
    justify-content: flex-start;
  }
`;
export const TextWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 570px;
  margin-bottom: 50px;
  margin-top: 50px;
  ${theme.breakpoints.down("sm")} {
    justify-content: flex-start;
  }
`;